module.exports = __webpack_public_path__ + "guvernulromaniei.png?eb9d7ef82e417625552929fcfd945572";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guvernulromaniei.png
// module id = 373
// module chunks = 0